import {
  createGroup as publicCreateGroup,
  updateGroup as publicUpdateGroup,
  deleteGroup as publicDeleteGroup,
  getGroup as publicGetGroup,
  getGroupBySlug as publicGetGroupBySlug,
  listGroups as publicListGroups,
  queryGroups as publicQueryGroups,
  typedQueryGroups as publicTypedQueryGroups,
} from './social-groups-v2-group-groups.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onGroupCreated as publicOnGroupCreated } from './social-groups-v2-group-groups.public.js';
import { onGroupDeleted as publicOnGroupDeleted } from './social-groups-v2-group-groups.public.js';
import { onGroupCoverChanged as publicOnGroupCoverChanged } from './social-groups-v2-group-groups.public.js';
import { onGroupDescriptionChanged as publicOnGroupDescriptionChanged } from './social-groups-v2-group-groups.public.js';
import { onGroupUpdated as publicOnGroupUpdated } from './social-groups-v2-group-groups.public.js';

export const createGroup: MaybeContext<
  BuildRESTFunction<typeof publicCreateGroup> & typeof publicCreateGroup
> = /*#__PURE__*/ createRESTModule(publicCreateGroup);
export const updateGroup: MaybeContext<
  BuildRESTFunction<typeof publicUpdateGroup> & typeof publicUpdateGroup
> = /*#__PURE__*/ createRESTModule(publicUpdateGroup);
export const deleteGroup: MaybeContext<
  BuildRESTFunction<typeof publicDeleteGroup> & typeof publicDeleteGroup
> = /*#__PURE__*/ createRESTModule(publicDeleteGroup);
export const getGroup: MaybeContext<
  BuildRESTFunction<typeof publicGetGroup> & typeof publicGetGroup
> = /*#__PURE__*/ createRESTModule(publicGetGroup);
export const getGroupBySlug: MaybeContext<
  BuildRESTFunction<typeof publicGetGroupBySlug> & typeof publicGetGroupBySlug
> = /*#__PURE__*/ createRESTModule(publicGetGroupBySlug);
export const listGroups: MaybeContext<
  BuildRESTFunction<typeof publicListGroups> & typeof publicListGroups
> = /*#__PURE__*/ createRESTModule(publicListGroups);
export const queryGroups: MaybeContext<
  BuildRESTFunction<typeof publicQueryGroups> & typeof publicQueryGroups
> = /*#__PURE__*/ createRESTModule(publicQueryGroups);
export const typedQueryGroups: MaybeContext<
  BuildRESTFunction<typeof publicTypedQueryGroups> &
    typeof publicTypedQueryGroups
> = /*#__PURE__*/ createRESTModule(publicTypedQueryGroups);
/**
 * Triggered when a group is created.
 */
export const onGroupCreated: BuildEventDefinition<typeof publicOnGroupCreated> &
  typeof publicOnGroupCreated = createEventModule(publicOnGroupCreated);
/**
 * Triggered when a group is deleted.
 */
export const onGroupDeleted: BuildEventDefinition<typeof publicOnGroupDeleted> &
  typeof publicOnGroupDeleted = createEventModule(publicOnGroupDeleted);
/**
 * Triggered when a group's logo is changed.
 */
export const onGroupCoverChanged: BuildEventDefinition<
  typeof publicOnGroupCoverChanged
> &
  typeof publicOnGroupCoverChanged = createEventModule(
  publicOnGroupCoverChanged
);
/**
 * Triggered when a group's description is changed.
 */
export const onGroupDescriptionChanged: BuildEventDefinition<
  typeof publicOnGroupDescriptionChanged
> &
  typeof publicOnGroupDescriptionChanged = createEventModule(
  publicOnGroupDescriptionChanged
);
/**
 * Triggered when a group is updated. See payload for more information about the specific trigger.
 */
export const onGroupUpdated: BuildEventDefinition<typeof publicOnGroupUpdated> &
  typeof publicOnGroupUpdated = createEventModule(publicOnGroupUpdated);

export {
  Type,
  AllowPolicy,
  StepKey,
  PrivacyStatus,
  IdentityType,
  ContentType,
  SortOrder,
  MembershipStatus,
  BMFeature,
  WebhookIdentityType,
} from './social-groups-v2-group-groups.universal.js';
export {
  Group,
  Events,
  Logo,
  GroupDetailsPosition,
  Image,
  Position,
  OnboardingStepSettings,
  AccessRestriction,
  AccessRestrictionDataOneOf,
  GroupDetails,
  CoverImage,
  GroupSettings,
  Identity,
  CreateGroupRequest,
  CreateGroupResponse,
  UpdateGroupRequest,
  UpdateGroupResponse,
  GroupCoverChanged,
  GroupDescriptionChanged,
  DeleteGroupRequest,
  DeleteGroupResponse,
  GetGroupRequest,
  GetGroupResponse,
  GetGroupBySlugRequest,
  GetGroupBySlugResponse,
  GetGroupIdBySlugRequest,
  GetGroupIdBySlugResponse,
  GlobalFeedPermissions,
  FeedPermissions,
  FeedItemPermissions,
  ListGroupsRequest,
  ListGroupsResponse,
  PagingMetadata,
  ListGroupsByUserIdRequest,
  ListGroupsByUserIdResponse,
  GroupWithMsId,
  QueryGroupsRequest,
  Query,
  Sorting,
  Paging,
  QueryGroupsResponse,
  QueryJoinedGroupsRequest,
  QueryJoinedGroupsResponse,
  QueryGroupsByMembershipRequest,
  GroupPermissions,
  QueryGroupsByMembershipResponse,
  ListGroupIntegrationsDataRequest,
  ListGroupIntegrationsDataResponse,
  GroupIntegrationsData,
  GetGroupMembersGroupIdsRequest,
  GetGroupMembersGroupIdsResponse,
  GetGroupBMFeaturesRequest,
  GetGroupBMFeaturesResponse,
  BMFeatures,
  QueryJoinedGroupsWithMemberRequest,
  QueryJoinedGroupsWithMemberResponse,
  GetPrivacyRequest,
  GetPrivacyResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  GroupCreatedEnvelope,
  GroupDeletedEnvelope,
  GroupCoverChangedEnvelope,
  GroupDescriptionChangedEnvelope,
  GroupUpdatedEnvelope,
  CreateGroupOptions,
  UpdateGroup,
  UpdateGroupOptions,
  GetGroupOptions,
  GetGroupBySlugOptions,
  ListGroupsOptions,
  QueryGroupsOptions,
  GroupsQueryResult,
  GroupsQueryBuilder,
  GroupQuerySpec,
} from './social-groups-v2-group-groups.universal.js';
export { utils } from './social-groups-v2-group-groups.universal.js';
export {
  TypeWithLiterals,
  AllowPolicyWithLiterals,
  StepKeyWithLiterals,
  PrivacyStatusWithLiterals,
  IdentityTypeWithLiterals,
  ContentTypeWithLiterals,
  SortOrderWithLiterals,
  MembershipStatusWithLiterals,
  BMFeatureWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  GroupQuery,
} from './social-groups-v2-group-groups.universal.js';
